import React from 'react';
import { Loadable } from 'shared/hocs/loadable';
import { Loader } from 'shared/ui/loader';


export const SurveyLoadable = Loadable({
    loader: (): any => import('./Survey').then((res) => res.Survey),
    loading: <Loader/>,
});
